import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import NewInvoice from "../views/NewInvoice.vue";
import NewAffiliate from "../views/NewAffiliate.vue";
import ChangePass from "../views/changePass.vue";
import Exit from "../views/Exit.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/", name: "login", component: Login },
    { path: "/login", name: "Login", component: Login }, 
    { path: "/new_invoice", name: "NewInvoice", component: NewInvoice }, 
    { path: "/new_affiliate", name: "NewAffiliate", component: NewAffiliate },
    { path: "/exit", name: "exit", component: Exit },
    { path: "/changue_pass", name: "changuepass", component: ChangePass },
  ],
});

export default router;
